import { BsThreeDots } from "react-icons/bs";
import { FaPlus, FaRegEdit, FaTrash } from "react-icons/fa";
import { GoSearch } from "react-icons/go";

import {
  IoIosAddCircleOutline,
  IoIosArrowBack,
  IoIosArrowForward,
  IoIosArrowRoundForward,
  IoIosCheckmark,
  IoMdArrowRoundBack,
  IoMdClose,
  IoMdNotificationsOutline,
} from "react-icons/io";
import {
  IoClose,
  IoEyeOutline,
  IoTimeOutline,
  IoCloudUploadOutline,
  IoReorderTwoSharp,
} from "react-icons/io5";
import {
  MdAttachFile,
  MdCake,
  MdCurrencyRupee,
  MdFastfood,
  MdKeyboardArrowDown,
  MdLogout,
  MdOutlineAccountBalanceWallet,
  MdOutlineCalendarMonth,
} from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { FcMenu } from "react-icons/fc";
import { AiOutlineDelete } from "react-icons/ai";
import { RiArrowDropDownLine, RiImageEditLine } from "react-icons/ri";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { CgMenuLeftAlt } from "react-icons/cg";
import { FaCheck } from "react-icons/fa";
import { FaTimes, FaMinus } from "react-icons/fa";
import { AiOutlineCheckCircle, AiOutlineCloseCircle } from "react-icons/ai";
import { FiDownload, FiPlusCircle } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import { TbEdit, TbMailCheck } from "react-icons/tb";
import { TiArrowDown, TiArrowUp, TiPlus } from "react-icons/ti";
import { HiCheckBadge, HiMiniArrowsUpDown } from "react-icons/hi2";
import {
  TiArrowSortedUp,
  TiArrowSortedDown,
  TiArrowUnsorted,
} from "react-icons/ti";
import { PiShoppingCart } from "react-icons/pi";
import { SlScreenSmartphone } from "react-icons/sl";
import { BiDotsVerticalRounded } from "react-icons/bi";

const icons = {
  BiDotsVerticalRounded,
  MdAttachFile,
  GoSearch,
  MdCake,
  IoClose,
  BsThreeDots,
  FaRegEdit,
  IoEyeOutline,
  FaTrash,
  FaMinus,
  IoIosArrowBack,
  IoIosArrowForward,
  FaArrowLeftLong,
  FaEye,
  FaEyeSlash,
  FiPlusCircle,
  FcMenu,
  MdKeyboardArrowDown,
  IoTimeOutline,
  IoCloudUploadOutline,
  AiOutlineDelete,
  RiArrowDropDownLine,
  IoIosAddCircleOutline,
  IoIosCheckmark,
  FaArrowRightLong,
  MdOutlineCalendarMonth,
  IoIosArrowRoundForward,
  IoReorderTwoSharp,
  CgMenuLeftAlt,
  FaCheck,
  FaTimes,
  AiOutlineCheckCircle,
  AiOutlineCloseCircle,
  FiDownload,
  FiEyeOff,
  TbEdit,
  TiPlus,
  RiImageEditLine,
  TiArrowUp,
  TiArrowDown,
  HiMiniArrowsUpDown,
  TiArrowSortedUp,
  TiArrowSortedDown,
  TiArrowUnsorted,
  IoMdArrowRoundBack,
  TbMailCheck,
  // canteen flow icons
  IoIosAddCircleOutline,
  PiShoppingCart,
  MdFastfood,
  FaPlus,
  IoMdClose,
  MdCurrencyRupee,
  MdOutlineAccountBalanceWallet,
  HiCheckBadge,
  MdOutlineAccountBalanceWallet,
  SlScreenSmartphone,
  MdLogout,
  IoMdNotificationsOutline,
};

export default icons;
